export default "__VITE_ASSET__COC40354__"